import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ContactStatesSkillObject } from './contat-states-skill.model';

@Injectable({
    providedIn: 'root'
})
export class ContactStatesSkillService {

    constructor(
        private cvApiService: CVApiService,
    ) { }

    async LoadData(moduleKey: string, isAutoRefresh = false, isFirstLoad = false){
        try {
            const url = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const queryString = `/api/v2/realtime/contactstatesskill/getcontactstatesskilldata/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            const response = await this.cvApiService.get<ContactStatesSkillObject[]>(queryString, url);

            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else
                throw response;
        }
        catch (e) {
            console.error("Failed getting Contact States by Skill data");
            throw e;
        }
    }
}
